// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__26Ujk","rootSmall":"AddTileButton_rootSmall__1KrU-"};